/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import "./ConnectForm.scss";
import { TextField, MenuItem, Button } from "@mui/material";
import { useParams } from "react-router";
import BreadcrumbsNav from "../breadCrumbMenu/BreadcrumbsNav";

const ConnectForm = () => {
  const { appName } = useParams();
  
  return (
    <div className="connect-form">
      <BreadcrumbsNav  overrides={{
              '/projects': {
                label: 'Projects',
                // icon: <FolderOpenOutlined />,
                path: '/projects/overview',
              },
              [`/projects/addconnection`]: {
                // label: project?.title,
                disabled: true,
              },
            }}/>
      <h1 className="title">Connect to {appName}</h1>

      <div className="form-group">
        <label>
          Connection name <span className="required">*</span>
        </label>
        <TextField
          fullWidth
          placeholder="My sixth Redshift account"
          variant="outlined"
          InputLabelProps={{ shrink: false }}
        />
        <p className="hint">Name your connection. You can reuse it in other recipes.</p>
      </div>

      <div className="form-group">
        <label>
          Location <span className="required">*</span>
        </label>
        <TextField
          fullWidth
          placeholder="Choose project or folder"
          variant="outlined"
          select
          InputLabelProps={{ shrink: false }}
        >
          <MenuItem value="project1">Project 1</MenuItem>
          <MenuItem value="project2">Project 2</MenuItem>
        </TextField>
      </div>

      <div className="form-group">
        <label>
          Connection type <span className="required">*</span>
        </label>
        <TextField
          fullWidth
          placeholder="Cloud"
          variant="outlined"
          select
          InputLabelProps={{ shrink: false }}
        >
          <MenuItem value="cloud">Cloud</MenuItem>
          <MenuItem value="onprem">On-Prem</MenuItem>
        </TextField>
        <p className="hint">
          If you want to connect using an on-prem group, please choose one from the dropdown.
          <a href="#" className="learn-more"> Learn more</a>
        </p>
      </div>

      <div className="form-group">
        <label>
          URL <span className="required">*</span>
        </label>
        <TextField
          fullWidth
          placeholder="jdbc:redshift://examplecluster.abc123xyz789.us-west-2.redshift.amazonaws.com:5439/dev"
          variant="outlined"
          InputLabelProps={{ shrink: false }}
        />
      </div>

      <div className="form-actions">
        <Button variant="contained" className="connect-btn">
          Connect
        </Button>
      </div>
    </div>
  );
};

export default ConnectForm;
